import React, { memo } from 'react';
import { Alert, Icon } from '@dexma/ui-components';
import i18n from 'asset/translation';

type ServerErrorType = {
    tryAgain: () => void;
    dataId: string;
};

const ServerErrorAlert = memo(({ tryAgain, dataId }: ServerErrorType) => (
    <Alert
        style={{ marginBottom: '12px' }}
        type='error'
        showIcon={false}
        className='server-error-alert'
        message={
            <>
                <span className='message'>
                    <Icon className='icon' name='warning' size={20} ariaLabel={i18n.t('dashboards.layouts.create.errorIconAriaLabel')} />
                    <span
                        style={{
                            fontWeight: 400,
                            fontSize: '14px',
                        }}
                    >
                        {i18n.t('dashboards.create.serverErrorMessage')}
                    </span>
                    &nbsp;
                    <span
                        data-testid='resubmit-button'
                        style={{
                            fontWeight: 400,
                            fontSize: '14px',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                        }}
                        onClick={tryAgain}
                        data-id={dataId}
                    >
                        {i18n.t('dashboards.create.serverErrorTryAgain')}
                    </span>
                </span>
            </>
        }
    />
));

export default ServerErrorAlert;
